module.exports = __webpack_public_path__ + "cardAvatarImg.png?a5795ffb59d6fd4854b8242bfc10dde0";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/cardAvatarImg.png
// module id = 193
// module chunks = 0